var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3335 4.14322V2.60352C4.3335 2.08575 4.75323 1.66602 5.271 1.66602H13.396C13.9138 1.66602 14.3335 2.08575 14.3335 2.60352V10.7285C14.3335 11.2463 13.9138 11.666 13.396 11.666H11.8389",
    stroke: "#030C21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.729 4.33398H2.604C2.08624 4.33398 1.6665 4.75372 1.6665 5.27148V13.3965C1.6665 13.9143 2.08624 14.334 2.604 14.334H10.729C11.2468 14.334 11.6665 13.9143 11.6665 13.3965V5.27148C11.6665 4.75372 11.2468 4.33398 10.729 4.33398Z",
    stroke: "#030C21",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.e1e33e8a.svg";
export { ForwardRef as ReactComponent };